export const detectMobile = () => typeof navigator !== 'undefined'
  && /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);

export const detectWindows = () => typeof navigator !== 'undefined'
  && navigator.platform.toLowerCase().includes('win');

export const detectApple = () => (
  ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform)
  || navigator.userAgent.includes('Mac')
  && 'ontouchend' in document
);
